import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function loadSearch () {
  return import(/* webpackChunkName: "pages/Search" */ 'pages/Search')
}

export default function getSearchPageComponentRouteUtil (
  props
) {
  if (SEARCH || (SERVER && global.SEARCH)) {
    const Component = require('pages/Search').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadSearch}
        {...props}
      />
    )
  }
}
